import { useCommunityUserUIStore } from '@communities/community-user-layer/stores/community-user.ui-store'

/**
 * Clear Pinia fallbacks that can mask fresh user-group query data after leaving a group.
 */
export function resetCommunitiesMembershipUiAfterLeaveGroup(): void {
  try {
    useCommunityUserUIStore().setCurrentCommunityUser(null)
  } catch {
    // Pinia may be unavailable in some test harnesses
  }
}
